// extracted by mini-css-extract-plugin
export default {"lds-spinner":"ButtonLoader_lds-spinner__6LTjh"};